import 'ays-shared/main.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'font-awesome/css/font-awesome.min.css';

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import miniToastr from 'mini-toastr';
import 'jquery';
import 'bootstrap';

import 'ays-shared/filters';
import LoadAndError from 'ays-shared/components/LoadAndError.vue';
import InfoRow from 'ays-shared/components/InfoRow.vue';
import BarcodeScanner from '@/components/BarcodeScanner.vue';
import constants from '@/constants';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

const version = process.env.VUE_APP_VERSION || 'dev';
const environment = process.env.VUE_APP_ENV || 'local';
console.log(`AYS Inventory version ${version} @ ${environment}`);

if (process.env.VUE_APP_SENTRY) {
  Sentry.init({
    release: `inventory@${version}`,
    environment,
    dsn: process.env.VUE_APP_SENTRY,
    integrations: [new Integrations.Vue({
      Vue,
      attachProps: true,
    })],
  });
}

miniToastr.init();
Vue.use(BootstrapVue);

Vue.component('load-and-error', LoadAndError);
Vue.component('info-row', InfoRow);
Vue.component('barcode-scanner', BarcodeScanner);

Vue.filter('locationName', (name) => {
  return constants.LOCATIONS[name] ? constants.LOCATIONS[name] : name;
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
